import { Injectable } from "@angular/core";

@Injectable()
export class GridCellExportStyleService {

    constructor() {
    }

    // customers = new Map<string, String>([
    //     ["birthdate", "dateFormat"],
    //     ["tot_spent", "currencyFormat"],
    //     ["discount_perc", "percentuageFormat"]
    // ]);

    items = new Map<string, string>([
        ["name", "compact-cell"]
    ]);

    history_e_invoices = new Map<string, string>([
        ["status", "wrap-cell"]
    ]);
}
